var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { class: ["drawer-menu", _vm.isActive ? "active" : ""] }, [
    _c(
      "a",
      {
        class: ["logo", _vm.hasApps ? "hamburger" : ""],
        attrs: { href: "#" },
        on: { click: _vm.toggleActive }
      },
      [
        _c("img", {
          staticClass: "shape-darwin-logo",
          attrs: { src: require("@/assets/logo.svg"), alt: "Engie Green" }
        })
      ]
    ),
    _vm._v(" "),
    _vm.apps && _vm.apps.length > 0
      ? _c(
          "ul",
          [
            _c(
              "li",
              { staticClass: "close", on: { click: _vm.toggleActive } },
              [_vm._m(0)]
            ),
            _vm._v(" "),
            _vm._l(_vm.apps, function(menu, index) {
              return _c(
                "li",
                {
                  key: index,
                  class: [menu.hasSubMenu() ? "with-submenu" : ""]
                },
                [
                  _c(
                    "a",
                    { attrs: { href: menu.href } },
                    [
                      menu.icon
                        ? _c("icon", { attrs: { name: menu.icon } })
                        : _vm._e(),
                      _c("span", [_vm._v(_vm._s(menu.label))])
                    ],
                    1
                  ),
                  _vm._v(" "),
                  menu.hasSubMenu()
                    ? _c(
                        "ul",
                        _vm._l(menu.subMenu, function(sub, subIndex) {
                          return _c("li", { key: index + subIndex }, [
                            _c(
                              "a",
                              { attrs: { href: sub.href } },
                              [
                                sub.icon
                                  ? _c("icon", { attrs: { name: sub.icon } })
                                  : _vm._e(),
                                _c("span", [_vm._v(_vm._s(sub.label))])
                              ],
                              1
                            )
                          ])
                        })
                      )
                    : _vm._e()
                ]
              )
            })
          ],
          2
        )
      : _vm._e()
  ])
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("button", { staticClass: "btn-icon" }, [
      _c("i", { staticClass: "material-icons" }, [_vm._v("close")])
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-4f99ab26", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4f99ab26","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/menu/DrawerMenu.vue
// module id = q0/w
// module chunks = 15